import { changeField } from 'publisher/actions/optInActions'
import { useFieldsStorage } from 'publisher/components/entities/Field/hooks/use-fields-storage'
import { useOptIn } from 'publisher/store'
import {
  getFieldErrorsBySlug,
  getFieldValueBySlug,
} from 'publisher/store/opt-in/optInSelectors'
import React from 'react'
import { useDispatch } from 'react-redux'
import { CommonPublisherCountryFieldEntityOrSubEntity } from 'src/publisher/shared/components/field/common-publisher-country-field-entity-or-sub-entity'
import { FieldEntityInterface } from 'src/shared/entities/field/field-entity.schema'

type CountryFieldProps = {
  entity: FieldEntityInterface
}

function CountryFieldNew({ entity }: CountryFieldProps) {
  const value = useOptIn(state => getFieldValueBySlug(state, entity.slug))
  const errors = useOptIn(state => getFieldErrorsBySlug(state, entity.slug))
  const dispatch = useDispatch()

  useFieldsStorage(entity.slug ?? '')

  return (
    <CommonPublisherCountryFieldEntityOrSubEntity
      entityOrSubEntity={entity}
      value={value}
      onChange={value => dispatch(changeField(entity.slug, value))}
      errors={errors}
    />
  )
}

export default CountryFieldNew
